export function logosSlider() {
    $(".logos-slider").each(function () {
        const isRight = $(this).hasClass("direction-right");

        $(this).infiniteslide({
            direction: isRight ? "right" : "left",
            speed: 10,
            pauseonhover: false
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/logosSlider.js